import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const AiInsightsModalContent: FC = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography fontWeight={700} variant="body2">
        {t("Your data already shows where things aren’t landing. AI helps you spot it.")}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t("AI Insights analyzes:")}
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            <Box component="span" fontWeight={700}>
              {t("Communication engagement data")}
            </Box>
            {t(" (opens, clicks, reactions)")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <Box component="span" fontWeight={700}>
              {t("Survey responses")}
            </Box>
            {t(" (engagement, pulse, lifecycle)")}
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "to highlight patterns across teams, roles, tenure, and locations - no more manual slicing and dicing your data or missing insights entirely.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t("AI Insights helps you spot:")}
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            {t("Teams that consistently engage less with communications")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("Engagement gaps between departments or regions")}
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            {t("Groups showing early retention risk signals")}
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "Instead of reviewing metrics message by message, AI Insights brings attention to the things that actually matter so you know where to focus.",
        )}
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        {t("Clearer signals. Less guesswork. Better follow-up.")}
      </Typography>
    </Box>
  );
};
